import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './portfolio.css';

const Portfolio = () => {

  const navigate = useNavigate();

  const filters = [
    'All',
    'Offline Events',
    'Digital Marketing',
    'Press Releases',
    'Magazines',
  ];

  const portfolioData = [

  // ✅ PRESS RELEASES (ONLY VALID ONES)

  {
    id: 1,
    category: 'Press Releases',
    slug: 'mudras-against-cancer',
    title: 'Mudras Against Cancer',
    desc: 'Exclusive interview and editorial feature on Odissi dancer and cancer survivor Shubhada Varadkar.',
    image: '/case-studies/mudras_against_cancer/mudra-coverphoto.png'
  },

  {
    id: 2,
    category: 'Press Releases',
    slug: 'rolling-with-the-punches',
    title: 'Rolling With The Punches',
    desc: 'Inspirational survivor feature on Indian boxer Ngangom Dingko Singh and his courageous battle against cancer.',
    image: '/case-studies/rolling_with_the_punches/rolling-cover.png'
  },

  {
    id: 3,
    category: 'Press Releases',
    slug: 'decoding-the-numbers',
    title: 'Decoding The Numbers',
    desc: 'Healthcare AI startup feature focused on innovation and modern medical diagnostics.',
    image: 'case-studies/decoding_the_numbers/decoding-cover.png'
  },

  {
    id: 4,
    category: 'Press Releases',
    slug: 'pharmeasy-feature',
    title: 'PharmEasy Feature',
    desc: 'Healthcare startup editorial feature focused on digital healthcare accessibility and innovation.',
    image: '/case-studies/pharmeasy_feature/pharmeasy-cover.png'
  },

  {
    id: 5,
    category: 'Press Releases',
    slug: 'brenna-huckaby-story',
    title: 'Brenna Huckaby Story',
    desc: 'Inspirational editorial feature highlighting resilience, courage and recovery.',
    image: 'case-studies/brenna_huckaby_story/brenna-cover.png'
  },

  {
    id: 6,
    category: 'Press Releases',
    slug: 'global-oncology-feature',
    title: 'Global Oncology Feature',
    desc: 'Healthcare organization feature focused on oncology awareness and collaboration.',
    image: '/case-studies/global_oncology_feature/global-cover.png'
  },

  {
    id: 7,
    category: 'Press Releases',
    slug: 'actrec-feature',
    title: 'ACTREC Feature',
    desc: 'Institutional feature highlighting cancer research and healthcare innovation.',
    image: '/case-studies/actrec_feature/actrec-cover.png'
  },

  {
    id: 8,
    category: 'Press Releases',
    slug: 'jipmer-feature',
    title: 'JIPMER Feature',
    desc: 'Healthcare institution feature focused on medical education and research.',
    image: '/case-studies/jipmer_feature/jipmer-cover.png'
  },

  {
    id: 9,
    category: 'Press Releases',
    slug: 'gcri-feature',
    title: 'GCRI Feature',
    desc: 'Cancer research institute feature focused on healthcare advancement.',
    image: '/case-studies/gcri_feature/gcri-cover.png'
  },

  {
    id: 10,
    category: 'Press Releases',
    slug: 'rajiv-gandhi-cancer-institute-feature',
    title: 'Rajiv Gandhi Cancer Institute Feature',
    desc: 'Hospital feature focused on cancer care, treatment and patient services.',
    image: 'case-studies/rgci_feature/rcgi-cover.png'
  },

  {
    id: 11,
    category: 'Press Releases',
    slug: 'icmr-nicpr-feature',
    title: 'ICMR-NICPR Feature',
    desc: 'Research feature focused on cancer prevention and healthcare awareness.',
    image: '/case-studies/icmr_nicpr_feature/imcr-cover.png'
  },

  {
    id: 12,
    category: 'Press Releases',
    slug: 'helping-hands-foundation-feature',
    title: 'Helping Hands Foundation Feature',
    desc: 'NGO feature highlighting healthcare support and social impact initiatives.',
    image: 'case-studies/helping_hands_feature/helping-cover.png'
  },

  {
    id: 13,
    category: 'Press Releases',
    slug: 'shadi-ganz-foundation-feature',
    title: 'Saviour On Wheels',
    desc: 'Inspirational healthcare feature highlighting Shadi Ganz Foundation’s Mammomobile initiative for rural cancer screening.',
    image: '/case-studies/shadi_ganz_foundation/shadi-cover.png'
  },

  {
    id: 14,
    category: 'Press Releases',
    slug: 'wholesome-rhapsody-feature',
    title: 'Sweet Treats',
    desc: 'Healthcare startup feature highlighting Wholesome Rhapsody and its customised desserts.',
    image: '/case-studies/wholesome_rhapsody/wholesome-cover.png'
  },

  {
    id: 15,
    category: 'Press Releases',
    slug: 'zuvius-blaze-of-brilliance',
    title: 'Blaze of Brilliance',
    desc: 'Editorial feature on Zuvius Lifesciences showcasing its journey and global oncology impact.',
    image: '/case-studies/zuvius_lifesciences_pages/blaze_of_brilliance_coverpage.png'
  },

  {
    id: 16,
    category: 'Press Releases',
    slug: 'pink-street-kims-feature',
    title: 'Pink Street Campaign at KIMS',
    desc: 'Large-scale cancer awareness campaign engaging students and healthcare professionals.',
    image: '/case-studies/wecanserve_feb_pages_15_19/pink_street_campaign_coverpage.png'
  },

  {
    id: 17,
    category: 'Press Releases',
    slug: 'yoddhas-ngo-feature',
    title: 'Hope… One Meal at a Time',
    desc: 'Inspirational NGO feature highlighting Yoddhas and its mission to support cancer patients.',
    image: '/case-studies/wecanserve_sep_pages_24_25/hope_one_meal_at_a_time_coverpage.png'
  },

  {
    id: 18,
    category: 'Press Releases',
    slug: 'the-happiness-trap-feature',
    title: 'The Happiness Trap',
    desc: 'Wellness feature exploring mental health, stress and acceptance.',
    image: '/case-studies/wecanserve_may_page_8/happiness_trap_coverpage.png'
  },

  {
    id: 19,
    category: 'Press Releases',
    slug: 'love-loss-and-more-feature',
    title: 'Love, Loss and More',
    desc: 'Emotional feature exploring human resilience, grief and strength.',
    image: '/case-studies/wecanserve_june_page_52/love_loss_and_more_coverpage.png'
  },

  {
    id: 20,
    category: 'Press Releases',
    slug: 'snapchat-to-surgery-feature',
    title: 'From Snapchat Filters to Operational Theatres',
    desc: 'Innovation feature on AR transforming modern surgical procedures.',
    image: '/case-studies/wecanserve_july_pages_26_27/from_snap_to operational_coverpage.png'
  },

  {
    id: 21,
    category: 'Press Releases',
    slug: 'rise-of-aspirin-feature',
    title: 'Rise of Aspirin',
    desc: 'Healthcare feature exploring the evolution and importance of aspirin.',
    image: '/case-studies/wecanserve_aug_pages_31_32/rise_of_aspirin_coverpage.png'
  },

  {
    id: 22,
    category: 'Press Releases',
    slug: 'heeding-signals-key-feature',
    title: 'Heeding Signals is Key',
    desc: 'Feature emphasizing early detection and warning signs in cancer.',
    image: '/case-studies/wecanserve_oct_page_58/heeding_signals_is_key_coverpage.png'
  },

  {
    id: 23,
    category: 'Press Releases',
    slug: 'banish-winter-blues-feature',
    title: 'Banish the Winter Blues',
    desc: 'Wellness feature on seasonal mental health and lifestyle improvements.',
    image: '/case-studies/page_54_extract/banish_the_winter_blues_coverpage.png'
  },

  {
    id: 24,
    category: 'Press Releases',
    slug: 'village-warrior-feature',
    title: 'The Village Warrior',
    desc: 'Social impact feature showcasing grassroots healthcare efforts.',
    image: '/case-studies/magazines_cover_extract_page_13/village_warriors_coverpage.png'
  },

  {
    id: 25,
    category: 'Press Releases',
    slug: 'a-healthy-future-feature',
    title: 'A Healthy Future',
    desc: 'Preventive healthcare feature focused on long-term wellness.',
    image: '/case-studies/magazines_cover_extract_page_20/healthy_future_coverpage.png'
  },

  {
    id: 26,
    category: 'Press Releases',
    slug: 'gut-microbiome-feature',
    title: 'Gut Microbiome',
    desc: 'Feature exploring gut health, immunity and disease prevention.',
    image: '/case-studies/wecanserve_april_page_13_gut_microbiome/gut_mibrobiome_coverpage.png'
  },

  // ✅ OFFLINE EVENTS (UNCHANGED)

  {
    id: 27,
    category: 'Offline Events',
    slug: 'you-we-can-campaign',
    title: 'YouWeCan Campaign',
    desc: 'Nationwide university awareness campaign engaging 10,000+ students.',
    image: '/offline-events/youwecan-cover.png'
  },

  {
    id: 28,
    category: 'Offline Events',
    slug: 'pink-street-campaign',
    title: 'Pink Street Campaign',
    desc: 'Large-scale experiential campaign featuring a record-setting pink ribbon installation.',
    image: '/offline-events/pinkstreet-cover.jpg'
  },

  {
    id: 29,
    category: 'Offline Events',
    slug: 'men-for-pink',
    title: 'Men For Pink Initiative',
    desc: 'Awareness initiative encouraging men to engage in breast cancer conversations.',
    image: '/offline-events/menforpink-cover.jpg'
  },

  {
    id: 30,
    category: 'Offline Events',
    slug: 'walk-for-cancer-care',
    title: 'Walk for Cancer Care',
    desc: 'Community awareness walk promoting early detection and cancer care awareness.',
    image: '/offline-events/walkforcancercare-cover.jpg'
  },

  // ================= MAGAZINES =================

{
  id: 31,
  category: 'Magazines',
  title: 'Path To Homegrown Excellence',
  desc: 'May 2019 edition focused on Indian healthcare innovation, oncology awareness and medical excellence.',
  image: '/magazines/cover/may_2019_path_to_homegrown_excellence.png',
  pdf: '/magazines/may-2019.pdf'
},

{
  id: 32,
  category: 'Magazines',
  title: 'Mapping The Mind',
  desc: 'April 2019 edition exploring neuroscience, mental health and cognitive healthcare awareness.',
  image: '/magazines/cover/april_2019_mapping_the_mind.png',
  pdf: '/magazines/apr-2019.pdf'
},

{
  id: 33,
  category: 'Magazines',
  title: 'Resurgence of Ayurveda',
  desc: 'March 2019 edition highlighting Ayurveda, holistic wellness and traditional healing systems.',
  image: '/magazines/cover/march_2019_resurgence_of_ayurveda.png',
  pdf: '/magazines/mar-2019.pdf'
},

{
  id: 34,
  category: 'Magazines',
  title: 'India’s Top Cancer Research Centres',
  desc: 'February 2019 edition showcasing leading cancer research institutes and healthcare advancements.',
  image: '/magazines/cover/february_2019_indias_top_5_cancer_research_centres.png',
  pdf: '/magazines/feb-2019.pdf'
},

{
  id: 35,
  category: 'Magazines',
  title: 'The Fine Print Healthcare',
  desc: 'January 2019 edition focused on healthcare systems, policy and oncology awareness.',
  image: '/magazines/cover/january_2019_the_fine_print_of_healthcare.png',
  pdf: '/magazines/jan-2019.pdf'
},

{
  id: 36,
  category: 'Magazines',
  title: 'Path To Homegrown Excellence',
  desc: 'December 2018 edition focused on healthcare progress, awareness and innovation.',
  image: '/magazines/cover/december_2018_altruist_docpreneur.png',
  pdf: '/magazines/dec-2018.pdf'
},

{
  id: 37,
  category: 'Magazines',
  title: 'Laurels For The Lifesavers',
  desc: 'November 2018 edition celebrating healthcare heroes, caregivers and medical contributors.',
  image: '/magazines/cover/november_2018_laurels_for_the_lifesavers.png',
  pdf: '/magazines/nov-2018.pdf'
},

{
  id: 38,
  category: 'Magazines',
  title: 'Crusaders On The Run',
  desc: 'October 2018 edition highlighting endurance, awareness campaigns and inspiring journeys.',
  image: '/magazines/cover/october_2018_crusaders_on_the_run.png',
  pdf: '/magazines/oct-2018.pdf'
},

{
  id: 39,
  category: 'Magazines',
  title: 'Cheer-Me-Apps',
  desc: 'September 2018 edition focused on digital healthcare apps, wellness technology and innovation.',
  image: '/magazines/cover/september_2018_cheer_me_apps.png',
  pdf: '/magazines/sep-2018.pdf'
},

{
  id: 40,
  category: 'Magazines',
  title: 'Finding Panacea',
  desc: 'August 2018 edition exploring healthcare discoveries, treatments and medical innovation.',
  image: '/magazines/cover/august_2018_finding_panacea.png',
  pdf: '/magazines/aug-2018.pdf'
},

{
  id: 41,
  category: 'Magazines',
  title: 'Fighting The Good Fight',
  desc: 'July 2018 edition centered around resilience, positivity and cancer awareness.',
  image: '/magazines/cover/july_2018_fighting_the_good_fight.png',
  pdf: '/magazines/jul-2018.pdf'
},

{
  id: 42,
  category: 'Magazines',
  title: 'Healing Holiday',
  desc: 'June 2018 edition promoting healing, wellness, travel and emotional well-being.',
  image: '/magazines/cover/june_2018_healing_holiday.png',
  pdf: '/magazines/june-2018.pdf'
},

{
  id: 43,
  category: 'Magazines',
  title: 'Elusive Trait Called Happiness',
  desc: 'May 2018 edition exploring happiness, emotions, mental wellness and self-awareness.',
  image: '/magazines/cover/may_2018_the_elusive_trait_of_happiness.png',
  pdf: '/magazines/may-2018.pdf'
},

{
  id: 44,
  category: 'Magazines',
  title: 'India’s Ancient Healers',
  desc: 'April 2018 edition highlighting traditional healing systems and healthcare wisdom.',
  image: '/magazines/cover/april_2018_indias_pain_healers.png',
  pdf: '/magazines/apr-2018.pdf'
},

{
  id: 45,
  category: 'Magazines',
  title: 'Icon Of Courage',
  desc: 'February 2018 edition featuring inspiring stories of strength, resilience and awareness.',
  image: '/magazines/cover/february_2018_icon_of_courage.png',
  pdf: '/magazines/feb-2018.pdf'
},

{
  id: 46,
  category: 'Magazines',
  title: 'The Big 7',
  desc: 'January 2018 edition focused on major healthcare challenges, awareness and oncology initiatives.',
  image: '/magazines/cover/january_2018_the_big.png',
  pdf: '/magazines/jan-2018.pdf'
},

{
  id: 47,
  category: 'Magazines',
  title: 'The Change Makers',
  desc: 'December 2017 edition featuring pioneers, innovators and changemakers in healthcare.',
  image: '/magazines/cover/december_2017_the_change_makers.png',
  pdf: '/magazines/december-2017.pdf'
},

{
  id: 48,
  category: 'Digital Marketing',
  slug: 'zuvius-lifesciences',
  title: 'Zuvius Lifesciences',
  desc: 'Strategic digital marketing campaigns focused on brand visibility, audience engagement and healthcare awareness.',
  image: '/home-digital.png'
},

];


  const [activeFilter, setActiveFilter] = useState('All');

  const filteredProjects =
    activeFilter === 'All'
      ? portfolioData
      : portfolioData.filter(
          (item) => item.category === activeFilter
        );

  return (

    <div className="portfolio-page">

      {/* HEADER */}

      <div className="portfolio-header-section">

        <div>

          <h1>Our Portfolio</h1>

          <p>
            A showcase of campaigns, productions, events and growth systems
            built by WeCanServe.
          </p>

        </div>

      </div>

      {/* FILTERS */}

      <div className="portfolio-filters">

        {filters.map((filter, index) => (

          <button
            key={index}
            className={`filter-btn ${activeFilter === filter ? 'active' : ''}`}
            onClick={() => setActiveFilter(filter)}
          >
            {filter}
          </button>

        ))}

      </div>

      {/* GRID */}

      <div className="portfolio-grid">

        {filteredProjects.map((item) => (

          <div
  className={`portfolio-main-card ${
    item.category === 'Magazines' ? 'magazine-card' : ''
  }`}
  key={item.id}
>

            <div className="portfolio-image">

              <img
                src={item.image}
                alt={item.title}
              />

            </div>

            <div className="portfolio-content">

              <span className="portfolio-category">
                {item.category}
              </span>

              <h3>{item.title}</h3>

              <p>{item.desc}</p>

              <button
  className="view-project-btn"

onClick={() => {

  if(item.category === 'Offline Events'){
  navigate(`/events/${item.slug}`);
} 
else if(item.category === 'Press Releases'){
  navigate(`/portfolio/${item.slug}`);
}
else if(item.category === 'Digital Marketing'){
  navigate(`/digital-marketing/${item.slug}`);
}
else if(item.category === 'Magazines'){
  window.open(item.pdf, '_blank');
}
}}
>
  View Project →
</button>

            </div>

          </div>

        ))}

      </div>

    </div>

  );

};

export default Portfolio;